const sounds = {
  login: new Audio('/loggedin.wav'),
  purchase: new Audio('/purchaseContender.wav'),
  menu: new Audio('/menuSelect.wav'),
  return: new Audio('/returnSound.wav'), // ✅ New sound
  ns: new Audio('/ns.wav'),
  act: new Audio('/act.wav'),
  bz: new Audio('/bz.wav'),
  draw: new Audio('/draw.wav'),
  gy: new Audio('/gy.wav'),
  set: new Audio('/set.wav'),
  shuffle: new Audio('/shuffle.wav'),
  ss: new Audio('/ss.wav'),
  message: new Audio('/menuSelect.wav') // Use existing sound for new messages
};

export function playSound(name) {
  const sound = sounds[name];
  if (sound) {
    sound.currentTime = 0;
    sound.volume = parseFloat(localStorage.getItem('bgmVolume')) || 0.5;
    sound.play().catch((err) => {
      console.warn(`⚠️ Sound '${name}' failed:`, err);
    });
  }
}
